export const UPDATE_MNOGO_CARD_ID = 'UPDATE_MNOGO_CARD_ID' as const

export const updateMnogoCardIdAction = (value: string | null | undefined) => ({
  type: UPDATE_MNOGO_CARD_ID,
  value,
})
